<template>
    <div class="wrapper">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'SpaceBetween',
    props: {
        w: {
            type: Number,
            default: 1,
        },
    },
    computed: {
        spacing() {
            return this.w * 4
        },
    },
    mounted() {
        const children = this.$el.children
        for (let i = 0; i < children.length - 1; i++) {
            children[i].style.marginRight = `${this.spacing}px`
        }
    },
}
</script>

<style scoped>
.wrapper {
    display: flex;
}
</style>
